import { MIN_WIDTH, NAVBAR_HEIGHT } from 'src/globals';
import { CssType, ThemeType } from 'src/theme/jss-types';

export const InvoiceDashboardStyles = (theme: ThemeType): CssType => ({
    mainDiv: {
        background: '#F5F4F2',
        display: 'flex',
        flexDirection: 'column',
        '& .ant-checkbox-inner': {
            width: '15px',
            height: '15px',
        },
        '& .anticon-down': {
            fontSize: '12px',
        },
        '& .ant-btn ant-dropdown-trigger': {
            borderColor: theme.primaryColor,
            color: theme.primaryColor,
        },
        minWidth: MIN_WIDTH,
    },
    pageContent: {
        padding: '12px 8px',
        height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
    },
    searchContainer: {
        borderRadius: '2px',
        background: '#FFF',
        boxShadow: '1px 1px 3px 0px rgba(0, 0, 0, 0.10)',
        padding: '12px 16px',
        marginBottom: '6px',
    },
    tabsContainer: {
        flexGrow: 1,
        '& .ant-tabs-nav': {
            padding: '8px 8px 0 8px',
            marginBottom: '4px',
            background: '#FFF',
        },
        '& .ant-tabs-tab': {
            border: '0 !important',
            background: '#FFF !important',
            padding: '10px 24px !important',
        },
        '& .ant-tabs-tab-active': {
            boxShadow: '0px -4px 0px 0px #4ABFE5 inset',
            color: '#1659CB',
            border: '0 !importany',
            // fontWeight: 600,
        },
    },
    filterDiv: {
        display: 'flex',
    },
    filterTitle: {
        padding: '4px 8px',
        borderRadius: '4px 0px 0px 4px',
        border: '0.5px solid #999',
        borderRight: 0,
        background: '#FAFAFA',
        color: '#111111',
        fontWeight: 600,
    },
    filterSelect: {
        '& .ant-select-selector': {
            borderRadius: '4px 0px 0px 4px !important',
            borderRight: 0,
            border: '0.5px solid #999 !important',
            background: '#FAFAFA !important',
            color: '#111111',
            fontWeight: 600,
        },
        background: '#FAFAFA',
    },
    filterOptionSelect: {
        '& .ant-select-selector': {
            borderRadius: '0px 4px 4px 0px !important',
            border: '0.5px solid #999 !important',
            color: '#111111',
            minHeight: '32px !important',
            padding: '3px 8px !important',
        },
        '& .ant-select-selection-overflow': {
            padding: '0 !important',
        },
        '& .ant-select-selection-item': {
            margin: '2px !important',
        },
        '& .ant-select-selection-placeholder': {
            padding: '0 !important',
        },
    },
    inputSearch: {
        '& .ant-input-group': {
            border: '0.5px solid #999 !important',
            borderRadius: '0px 4px 4px 0px !important',
        },

        '& .ant-input': {
            border: 'none',
            '&:focus': {
                border: 'none',
                boxShadow: 'none !important',
            },
        },
        '& .ant-input-group-addon:last-child .ant-input-search-button:not(.ant-btn-primary)': {
            border: 'none',
        },
    },
    dateFilter: {
        border: '0.5px solid #999 !important',
        borderLeft: 0,
        borderRadius: '0px 4px 4px 0px !important',
    },
    filterCard: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '8px',
        background: '#FFF',
        padding: '12px 16px',
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        gap: '16px',
    },
    uploadIcon: {
        color: '#1659CB !important',
        borderRadius: '4px',
        border: '1px solid #1659CB',
        fontSize: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '26px',
        width: '26px',
        cursor: 'pointer',
    },
    uploadIconDisabled: {
        color: '#CCCCCC !important',
        borderRadius: '4px',
        border: '1px solid #CCCCCC',
        fontSize: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '26px',
        width: '26px',
        cursor: 'not-allowed !important',
        backgroundColor: '#f5f5f5',
    },
    bulkUploadButton: {
        borderRadius: '4px !important',
        backgroundColor: '#1659CB !important',
        color: '#FFFFFF !important',
        border: '1px solid #1659CB !important',
        '&:hover': {
            backgroundColor: '#1659CB !important',
            color: '#FFFFFF !important',
            border: '1px solid #1659CB !important',
        },
        '&:focus': {
            backgroundColor: '#1659CB !important',
            color: '#FFFFFF !important',
            border: '1px solid #1659CB !important',
        },
    },
    radioGroup: {
        display: 'flex',
        flexDirection: 'column',
        '& .ant-radio-wrapper': {
            fontSize: '12px',
            color: '#111111',
        },
        '& .ant-radio-wrapper-checked': {
            fontWeight: 600,
        },
    },
    warningTitle: {
        color: ' #111',
        fontSize: '16px',
        fontWeight: 600,
    },
    warningText: {
        fontSize: '12px',
        color: '#111111',
        margin: '12px 0 8px',
    },
    warningIcon: {
        color: '#FFFFFF',
        background: '#F0A105',
        marginRight: '4px',
        borderRadius: '20px',
        height: '20px',
        width: '20px',
        textAlign: 'center',
    },
    tableParent: {
        margin: '8px',
        '& .ant-table-tbody > tr > td': {
            wordWrap: 'break-word',
            wordBreak: 'break-all',
            '& a': {
                color: '#1659CB',
            },
        },
        '& .ant-table-thead': {
            color: '#333333',
        },
        '& .ant-table-thead > tr > th': {
            wordBreak: 'break-word',
            backgroundColor: '#F2F7FC',
            color: '#333333',
            overflow: 'hidden',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '12px',
            padding: '16px',
            borderRight: '0.5px solid #DDD',
            '& .ant-table-column-title': {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                width: '100%',
            },
        },
        '& .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before': {
            backgroundColor: 'unset',
        },
        '& .ant-table-row > td': {
            fontSize: '12px',
            lineHeight: '14px',
            padding: '10px 12px',
            color: '#333333',
            fontWeight: '500',
            borderRight: '0.5px solid #DDD',
        },
        '& .ant-table-row-selected > td': {
            backgroundColor: `#4ABFE533 !important`,
        },
    },
});
